/**
 * Отправляет ли рекламодатель счета в 1С. Нет рекламодателя или бэк не отдал поле —
 * считаем, что отправляет: так же по умолчанию делает бэк.
 */
export const isAdvertiserSendingInvoicesTo1C = (
    advertiser: { send_invoices_to_1c?: boolean | null } | null | undefined,
): boolean => advertiser?.send_invoices_to_1c !== false;
